import * as React from "react";
import { SummaryCard } from "kw/admin/components/SummaryCard";
import { useBreakpoint } from "kanopi-components/useBreakpoint";
import { SummaryTable } from "kw/admin/components/SummaryTable";
import { DIVIDER } from "baseui/table-semantic";
import { usePaymentMethod } from "kw/components/PaymentMethod/usePaymentMethod";
import { EditPaymentMethodButton } from "kw/components/PaymentMethod/EditPaymentMethodlModal";

type PaymentMethodData = {
  id: string;
  label: string;
  value: string | undefined;
};
export const PaymentMethodCard: React.FC = () => {
  const { paymentMethod, setRefresh, refresh } = usePaymentMethod();
  const { isSmall } = useBreakpoint();
  const columnSchema = [
    {
      header: "",
      id: "id",
      children: (row: PaymentMethodData) => row?.label,
      sortable: false,
      overrides: {
        TableBodyCell: {
          style: () => ({
            paddingLeft: 0,
            whiteSpace: isSmall ? "normal" : "nowrap",
          }),
        },
      },
    },
    {
      header: "",
      id: "id",
      children: (row: PaymentMethodData) => row?.value,
      sortable: false,
      overrides: {
        TableBodyCell: {
          style: () => ({
            width: "100%",
          }),
        },
      },
    },
  ];
  const data = [
    {
      id: "1",
      label: "Card type",
      value: paymentMethod?.cardType,
    },
    {
      id: "2",
      label: "Last4 digits",
      value: paymentMethod?.cardNumber,
    },
    {
      id: "3",
      label: "Expiry date",
      value: paymentMethod?.expiryDate,
    },
  ];

  const handleSubmit = () => {
    setRefresh(!refresh);
  };

  return (
    <SummaryCard
      title="Default payment method"
      ctas={[
        <EditPaymentMethodButton
          title="Update"
          handleSubmit={handleSubmit}
          key="edit-payment-method"
        />,
      ]}
    >
      <SummaryTable
        data={data}
        columnSchema={columnSchema}
        divider={DIVIDER.clean}
        overrides={{
          TableBodyRow: {
            style: {
              ":first-child td": {
                borderTopWidth: 0,
                borderTopStyle: "none",
              },
            },
          },
        }}
      />
    </SummaryCard>
  );
};
